import { render, staticRenderFns } from "./Wizard-Skill.vue?vue&type=template&id=751ec246&scoped=true"
import script from "./Wizard-Skill.vue?vue&type=script&lang=js"
export * from "./Wizard-Skill.vue?vue&type=script&lang=js"
import style0 from "./Wizard-Skill.vue?vue&type=style&index=0&id=751ec246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751ec246",
  null
  
)

export default component.exports